import * as T from '../../../store/types'
import Vue from 'vue'

export default {
  [T.UPDATE_CARD_LIST](state, payload) {
    let existingList = []
    if (payload.new) {
      payload = [...[payload]]
      existingList = [...state.cardList]
    }
    state.cardList = []
    if (payload.length > 0) {
      for (let i in payload) {
        state.cardList.push({
          value: payload[i].card_id,
          label: `${payload[i].card_type} ${payload[i].card_number} Exp:${payload[i].card_expiry}`,
        })
      }
      if (existingList.length > 0) {
        state.cardList = [...state.cardList, ...existingList]
      }
    }
  },

  [T.SET_SHIP_CYCLE](state, payload) {
    state.autoshipShippingCycle = {
      billOn: payload.billOnDate,
      billingCycle: payload.billingCycle,
    }
  },

  [T.SET_PAYMENT_INFO](state, payload) {
    state.autoshipPaymentInfo = payload
  },

  [T.SET_SHIPPING_INFO](state, payload) {
    state.autoshipShippingInfo = payload
  },
  [T.SET_BILLING_INFO](state, payload) {
    state.autoshipBillingInfo = payload
  },

  [T.SET_AUTOSHIP_SUBSCRIPTION_LIST](state, payload) {
    Vue.set(state.subscriptionList, 'list', payload.list)
  },
  [T.SET_AUTOSHIP_SUBSCRIPTION_DETAIL](state, payload) {
    state.subscriptionDetail = payload
  },

  [T.SET_SUBSCRIPTION_LIST_PAGINATION_META](state, payload) {
    state.subscriptionListPaginationMeta = payload.pagination
  },

  [T.CLEAR_AUTOSHIP_DATA](state, type) {
    if (type === 'autoship' || !type) {
      state.autoshipShippingCycle = {}
      state.autoshipPaymentInfo = null
      state.autoshipBillingInfo = {}
      state.autoshipShippingInfo = {}
    }
  },

  [T.AUTOSHIP_DATA](state, data) {
    state.autoshipData = data
  },
}
